import store from "../../store";
import { message } from "ant-design-vue";
import _ from "lodash";

const ControllerTypes = {
    EVERY: "every",
};

function checkPermission(permissions, every = false) {
    if (typeof permissions === "string") permissions = [permissions];
    if (!Array.isArray(permissions) || permissions.length === 0) {
        return true;
    }

    const isRoot = _.get(store.state.auth.user, "role.isRoot", false);
    const isAdmin = store.state.auth.adminUser !== null;
    const userPermissions = _.get(store.state.auth.user, "role.permissions", []).map((permission) => permission.name);

    const everyPermission = permissions.every((permission) => userPermissions.includes(permission));
    const somePermission = permissions.some((permission) => userPermissions.includes(permission));

    return isRoot || isAdmin || (every ? everyPermission : somePermission);
}

const NoPermission = {
    name: "NoPermission",
    render(h) {},
};

const PermissionController = {
    name: "PermissionController",
    functional: true,
    render(h, { props, slots }) {
        const isEvery = props.controller === ControllerTypes.EVERY;
        const permissions = props.permissions;
        const hasPermission = checkPermission(permissions, isEvery);
        return hasPermission ? slots().default : h(NoPermission);
    },
};

PermissionController.check = checkPermission;
PermissionController.sendError = (customMessage) => {
    message.error(customMessage || "Bu işlemi yapmaya yetkiniz yok.");
};
export default PermissionController;
